// extracted by mini-css-extract-plugin
export default {"container":"xUOohv","link":"Z3Kvcl","img":"uHSUMd"};